import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">用户好评</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">来自全国各地用户的真实评价</p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {commentsData.map((comment, idx) => (
            <div key={idx} className="p-5 bg-background-100 rounded-lg border border-background-200/60">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 flex-shrink-0 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-sm font-bold">
                  {comment.avatar}
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{comment.text}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}